<template>
  <div class="page">
    <p class="p1">
      积分
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="userIntegral-class">
      <div @click="clickUserIntegralDetailed(1)">
        <span>账户积分：</span>
        <span>{{integral}}</span>
      </div>
      <!-- <nut-button @click="openSwitch('isVisible')" class="newCard-class">兑换</nut-button> -->
      <nut-button class="newCard-class" @click="exchangeButton">去兑换</nut-button>
    </div>
    <div class="detail-box">
      <ul>
        <li class="li_class" v-for="(item,index) in dataList" :key="index">
          <p>
            <span>{{item.iccid}}</span>
            <span @click="clickUserIntegralDetailed(2,item.iccid)">卡积分：{{item.integral}}</span>
          </p>
          <p>
            <span>卡状态：{{item.showStatus}}</span>
            <nut-button small @click="cardUnbound(item.iccid)">去兑换</nut-button>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { wx_userBindCardList } from "@/api/api.js"; 
export default {
  data() {
    return {
      integral:0,
      dataList:[],
    };
  },
  computed: {},
  methods: {
    // 卡状态转换
    transferCardStatus(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 账户积分明细
    clickUserIntegralDetailed(type,iccid){
      this.$router.push({
        name: "userPointsDetails",
        query: {
          type: "1",
          iccid:iccid
        }
      });
    },
    // 初始化数据
    initData(){
      wx_userBindCardList().then(res => {
        if(res.data.code == 200){
          this.integral = res.data.data.integral;
          this.dataList = res.data.data.bindCardBackDtoList;
          this.dataList.map(item => {
            item.showStatus = this.transferCardStatus(item.showStatus)
          })
        }
      })
    },
    // 账户兑换积分
    exchangeButton(){
      this.$router.push({
        name: "userRedeem",
        query: {
          type: "1",
        }
      });
    },
    // 卡积分兑换
    cardUnbound(iccid){
      this.$router.push({
        name: "userRedeem",
        query: {
          type: "2",
          iccid:iccid
        }
      });
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    window.document.title = "积分";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .userIntegral-class{
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      background: #F94040;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/ .nut-button{
        background:#F94040;
        font-size: 14px;
        padding: 0 25px;
        margin-left: 10px;
      }
    }
    .detail-box{
      width: 100%;
    }
    .li_class{
      padding: 5px 13px;
      background: #fff;
      width: 100%;
      height: 65px;
      font-size: 13px;
      border-bottom: 2px solid #ededed;
      p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0;
        /deep/ .nut-button.small{
          height: 25px;
          padding: 0 7px;
          font-size: 12px;
          border-radius:5px;
          background:#F94040;
        }
      }
    }
  }
</style>

